import React from "react";

const ApproveRefundModal = ({
  isOpen,
  onClose,
  onConfirm,
  ticketNumber,
  refundAmount,
}) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="refund-modal">
        <h5>Approve Refund for ticket number #{ticketNumber}</h5>
        <p>
          The customer will be refunded <strong>R{refundAmount}</strong>.
        </p>
        <p>
          Once approved, <strong>Karamale</strong> will begin processing the
          refund automatically. This action is final and the ticket will be
          permanently invalidated.
        </p>
        <div className="modal-actions">
          <button onClick={onConfirm} className="save-btn">
            Approve
          </button>
          <button onClick={onClose} className="cancel-btn">
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default ApproveRefundModal;
